// extracted by mini-css-extract-plugin
module.exports = {"small_statistics_container":"SmallCharts_small_statistics_container__2Vnwg","button_switch":"SmallCharts_button_switch__26hnW","active":"SmallCharts_active__2xAP3"};